import { FormErrorMessage } from '@metservicedev/met-ui';
import React from 'react';

import { useSupplyErrorMessage } from './ValidationContainer';

type Props = {
  className?: string;
  message?: string;
  showRequired?: boolean;
};

export const ValidationMessage: React.FC<Props> = ({ className, message, showRequired }) => {
  const error = (message !== 'Required' || showRequired) ? message : undefined;
  const supplied = useSupplyErrorMessage(error);
  return supplied ? undefined : (
    <FormErrorMessage className={className}>
      {error}
    </FormErrorMessage>
  );
};
